module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "90px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('section', {
    staticClass: "section section-white"
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否包邮:"
    }
  }, [(_vm.templatesId) ? _c('el-radio', {
    attrs: {
      "disabled": "",
      "label": "0"
    },
    model: {
      value: (_vm.form.is_free),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_free", $$v)
      },
      expression: "form.is_free"
    }
  }, [_vm._v("自定义运费")]) : _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.is_free),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_free", $$v)
      },
      expression: "form.is_free"
    }
  }, [_vm._v("自定义运费")]), _vm._v(" "), (_vm.templatesId) ? _c('el-radio', {
    attrs: {
      "disabled": "",
      "label": "1"
    },
    model: {
      value: (_vm.form.is_free),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_free", $$v)
      },
      expression: "form.is_free"
    }
  }, [_vm._v("卖家承担运费")]) : _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.is_free),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_free", $$v)
      },
      expression: "form.is_free"
    }
  }, [_vm._v("卖家承担运费")]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("选择了卖家承担运费，运费计算和包邮规则设置将会丢失！")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.is_free == 0),
      expression: "form.is_free == 0"
    }],
    attrs: {
      "label": "计价方式:"
    }
  }, [(_vm.templatesId) ? _c('el-radio', {
    attrs: {
      "disabled": "",
      "label": "1"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按重量")]) : _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按重量")]), _vm._v(" "), (_vm.templatesId) ? _c('el-radio', {
    attrs: {
      "disabled": "",
      "label": "2"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按件数")]) : _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按件数")]), _vm._v(" "), (_vm.templatesId) ? _c('el-radio', {
    attrs: {
      "disabled": "",
      "label": "3"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按金额")]) : _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按金额")]), _vm._v(" "), (_vm.templatesId) ? _c('el-radio', {
    attrs: {
      "disabled": "",
      "label": "4"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按体积")]) : _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.form.valuation),
      callback: function($$v) {
        _vm.$set(_vm.form, "valuation", $$v)
      },
      expression: "form.valuation"
    }
  }, [_vm._v("按体积")]), _vm._v(" "), _c('p', {
    staticClass: "frm-tips"
  }, [_vm._v("运费模版保存后，计费方式将无法切换！！")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否启用:"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_vm._v("禁用")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.is_free == 1),
      expression: "form.is_free == 1"
    }],
    attrs: {
      "label": "不配送城市:"
    }
  }, [_c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("不配送城市（优先级最高）")]), _vm._v(" "), (_vm.nopost_self_conf && _vm.nopost_self_conf.length > 0) ? _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v(_vm._s(_vm._f("formatCityData")(_vm.nopost_self_conf, _vm.district)))]) : _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v("暂无数据")]), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleSelfNoPostEditArea()
      }
    }
  }, [_vm._v("编辑地区\n                ")])], 1)])])], 1)]), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.is_free == 0),
      expression: "form.is_free == 0"
    }],
    attrs: {
      "span": 16
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.valuation == 1),
      expression: "form.valuation == 1"
    }],
    staticClass: "section section-white"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("运费计算:")]), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("默认运费:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "140"
    }
  }, [_vm._v("\n              重量（kg以内）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_conf[0].start_standard),
      callback: function($$v) {
        _vm.$set(_vm.fee_conf[0], "start_standard", $$v)
      },
      expression: "fee_conf[0].start_standard"
    }
  }), _vm._v("\n              运费（元）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_conf[0].start_fee),
      callback: function($$v) {
        _vm.$set(_vm.fee_conf[0], "start_fee", $$v)
      },
      expression: "fee_conf[0].start_fee"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "font-bold"
  }, [_vm._v("增重运费:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "140"
    }
  }, [_vm._v("\n              每增加（kg内）：\n              "), _c('el-input', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.fee_conf[0].add_standard),
      callback: function($$v) {
        _vm.$set(_vm.fee_conf[0], "add_standard", $$v)
      },
      expression: "fee_conf[0].add_standard"
    }
  }), _vm._v("\n              增加（元）：\n              "), _c('el-input', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.fee_conf[0].add_fee),
      callback: function($$v) {
        _vm.$set(_vm.fee_conf[0], "add_fee", $$v)
      },
      expression: "fee_conf[0].add_fee"
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区城市设置运费")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fee_conf.slice(1),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "运送到",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleWeightFeeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量(kg)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.start_standard),
            callback: function($$v) {
              _vm.$set(scope.row, "start_standard", $$v)
            },
            expression: "scope.row.start_standard"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首费(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.start_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "start_fee", $$v)
            },
            expression: "scope.row.start_fee"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续重(kg)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.add_standard),
            callback: function($$v) {
              _vm.$set(scope.row, "add_standard", $$v)
            },
            expression: "scope.row.add_standard"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续费(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.add_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "add_fee", $$v)
            },
            expression: "scope.row.add_fee"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleWeightFeeDeleteArea(scope.$index)
            }
          }
        }, [_vm._v("删除\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('fee_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("不配送城市（优先级最高）")]), _vm._v(" "), (_vm.nopost_conf && _vm.nopost_conf.length > 0) ? _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v(_vm._s(_vm._f("formatCityData")(_vm.nopost_conf, _vm.district)))]) : _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v("暂无数据")]), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleWeightNoPostEditArea()
      }
    }
  }, [_vm._v("编辑地区\n              ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "font-bold"
  }, [_c('el-checkbox', {
    attrs: {
      "value": _vm.priceFreeStatus
    },
    model: {
      value: (_vm.priceFreeStatus),
      callback: function($$v) {
        _vm.priceFreeStatus = $$v
      },
      expression: "priceFreeStatus"
    }
  }), _vm._v("\n            指定条件包邮:\n          ")], 1), _vm._v(" "), (_vm.priceFreeStatus) ? _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区设置包邮规则")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.free_conf,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "地区设置",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), (scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleWeightFreeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")]) : _vm._e()]
      }
    }], null, false, 3328253493)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包邮条件(kg)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.freetype),
            callback: function($$v) {
              _vm.$set(scope.row, "freetype", $$v)
            },
            expression: "scope.row.freetype"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), (1 == scope.row.freetype || 3 == scope.row.freetype) ? _c('span', [_vm._v("在 "), _c('el-input', {
          staticClass: "inline-input",
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.inweight),
            callback: function($$v) {
              _vm.$set(scope.row, "inweight", $$v)
            },
            expression: "scope.row.inweight"
          }
        }), _vm._v(" kg内包邮")], 1) : _vm._e(), _vm._v(" "), (2 == scope.row.freetype || 3 == scope.row.freetype) ? _c('span', [(3 == scope.row.freetype) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" "), _c('el-input', {
          staticClass: "inline-input",
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.upmoney),
            callback: function($$v) {
              _vm.$set(scope.row, "upmoney", $$v)
            },
            expression: "scope.row.upmoney"
          }
        }), _vm._v(" 元以上包邮")], 1) : _vm._e()]
      }
    }], null, false, 2776735877)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(0 != scope.$index) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleWeightFreeDeleteArea(scope.$index)
            }
          }
        }, [_vm._v("删除\n                  ")]) : _vm._e()]
      }
    }], null, false, 3523421848)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('free_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.valuation == 2),
      expression: "form.valuation == 2"
    }],
    staticClass: "section section-white"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("运费计算:")]), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("默认运费:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "140"
    }
  }, [_vm._v("\n              件数（件以内）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_number_conf[0].start_standard),
      callback: function($$v) {
        _vm.$set(_vm.fee_number_conf[0], "start_standard", $$v)
      },
      expression: "fee_number_conf[0].start_standard"
    }
  }), _vm._v("\n              运费（元）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_number_conf[0].start_fee),
      callback: function($$v) {
        _vm.$set(_vm.fee_number_conf[0], "start_fee", $$v)
      },
      expression: "fee_number_conf[0].start_fee"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "font-bold"
  }, [_vm._v("增件运费:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "140"
    }
  }, [_vm._v("\n              每增加（件内）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_number_conf[0].add_standard),
      callback: function($$v) {
        _vm.$set(_vm.fee_number_conf[0], "add_standard", $$v)
      },
      expression: "fee_number_conf[0].add_standard"
    }
  }), _vm._v("\n              增加（元）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_number_conf[0].add_fee),
      callback: function($$v) {
        _vm.$set(_vm.fee_number_conf[0], "add_fee", $$v)
      },
      expression: "fee_number_conf[0].add_fee"
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区城市设置运费")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fee_number_conf.slice(1),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "运送到"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleNumberFeeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首件(件)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.start_standard),
            callback: function($$v) {
              _vm.$set(scope.row, "start_standard", $$v)
            },
            expression: "scope.row.start_standard"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首费(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.start_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "start_fee", $$v)
            },
            expression: "scope.row.start_fee"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续件(件)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.add_standard),
            callback: function($$v) {
              _vm.$set(scope.row, "add_standard", $$v)
            },
            expression: "scope.row.add_standard"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续费(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.add_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "add_fee", $$v)
            },
            expression: "scope.row.add_fee"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleNumberFeeDeleteArea(scope.$index)
            }
          }
        }, [_vm._v("删除\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('fee_number_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("不配送城市（优先级最高）")]), _vm._v(" "), (_vm.nopost_number_conf && _vm.nopost_number_conf.length > 0) ? _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v(_vm._s(_vm._f("formatCityData")(_vm.nopost_number_conf, _vm.district)))]) : _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v("暂无数据")]), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleNumberNoPostEditArea()
      }
    }
  }, [_vm._v("编辑地区\n              ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "font-bold"
  }, [_c('el-checkbox', {
    attrs: {
      "value": _vm.numberFreeStatus
    },
    model: {
      value: (_vm.numberFreeStatus),
      callback: function($$v) {
        _vm.numberFreeStatus = $$v
      },
      expression: "numberFreeStatus"
    }
  }), _vm._v("\n            指定条件包邮:\n          ")], 1), _vm._v(" "), (_vm.numberFreeStatus) ? _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区设置包邮规则")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.free_number_conf,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "地区设置",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), (scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleNumberFreeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")]) : _vm._e()]
      }
    }], null, false, 1605042294)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包邮条件(件)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.freetype),
            callback: function($$v) {
              _vm.$set(scope.row, "freetype", $$v)
            },
            expression: "scope.row.freetype"
          }
        }, _vm._l((_vm.options_number), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), (1 == scope.row.freetype || 3 == scope.row.freetype) ? _c('span', [_vm._v("满 "), _c('el-input', {
          staticClass: "inline-input",
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.upquantity),
            callback: function($$v) {
              _vm.$set(scope.row, "upquantity", $$v)
            },
            expression: "scope.row.upquantity"
          }
        }), _vm._v(" 件包邮")], 1) : _vm._e(), _vm._v(" "), (2 == scope.row.freetype || 3 == scope.row.freetype) ? _c('span', [(3 == scope.row.freetype) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" "), _c('el-input', {
          staticClass: "inline-input",
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.upmoney),
            callback: function($$v) {
              _vm.$set(scope.row, "upmoney", $$v)
            },
            expression: "scope.row.upmoney"
          }
        }), _vm._v(" 元以上包邮")], 1) : _vm._e()]
      }
    }], null, false, 325867158)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(0 != scope.$index) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleNumberFreeDeleteArea(scope.$index)
            }
          }
        }, [_vm._v("删除\n                  ")]) : _vm._e()]
      }
    }], null, false, 193621883)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('free_number_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.valuation == 3),
      expression: "form.valuation == 3"
    }],
    staticClass: "section section-white"
  }, [_c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区城市设置运费")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fee_money_conf,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "运送到"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), (scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleMoneyFeeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额上下限(元)",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rules), function(money_key, money_index) {
          return _c('div', {
            staticStyle: {
              "margin-top": "5px"
            }
          }, [_c('el-input', {
            staticClass: "inline-input",
            staticStyle: {
              "width": "100px"
            },
            attrs: {
              "disabled": ""
            },
            model: {
              value: (money_key.up),
              callback: function($$v) {
                _vm.$set(money_key, "up", $$v)
              },
              expression: "money_key.up"
            }
          }), _vm._v("\n                    -\n                    "), (money_key.now > 0) ? _c('el-input', {
            staticClass: "inline-input",
            staticStyle: {
              "width": "100px"
            },
            attrs: {
              "disabled": ""
            },
            on: {
              "blur": function($event) {
                return _vm.handleInputDownMoney(money_key.down, money_index, scope.$index)
              }
            },
            model: {
              value: (money_key.down),
              callback: function($$v) {
                _vm.$set(money_key, "down", $$v)
              },
              expression: "money_key.down"
            }
          }) : _c('el-input', {
            staticClass: "inline-input",
            staticStyle: {
              "width": "100px"
            },
            on: {
              "blur": function($event) {
                return _vm.handleInputDownMoney(money_key.down, money_index, scope.$index)
              }
            },
            model: {
              value: (money_key.down),
              callback: function($$v) {
                _vm.$set(money_key, "down", $$v)
              },
              expression: "money_key.down"
            }
          })], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费(元)",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rules), function(money_key) {
          return _c('div', {
            staticStyle: {
              "margin-top": "5px"
            }
          }, [_c('el-input', {
            staticClass: "inline-input",
            staticStyle: {
              "width": "100px"
            },
            model: {
              value: (money_key.basefee),
              callback: function($$v) {
                _vm.$set(money_key, "basefee", $$v)
              },
              expression: "money_key.basefee"
            }
          })], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "add_standard",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rules), function(money_key, money_index) {
          return ((scope.row.rules.length - 1) == money_index) ? _c('div', [(scope.$index != 0 || money_index != 0) ? _c('el-button', {
            attrs: {
              "size": "mini",
              "icon": "delete",
              "type": "danger"
            },
            on: {
              "click": function($event) {
                return _vm.handleMoneyFeeDeleteArea(scope.$index, money_index)
              }
            }
          }, [_vm._v("删除\n                    ")]) : _vm._e()], 1) : _c('div', {
            staticStyle: {
              "height": "45px"
            }
          })
        })
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('fee_money_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("不配送城市（优先级最高）")]), _vm._v(" "), (_vm.nopost_money_conf && _vm.nopost_money_conf.length > 0) ? _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v(_vm._s(_vm._f("formatCityData")(_vm.nopost_money_conf, _vm.district)))]) : _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v("暂无数据")]), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleMoneyNoPostEditArea()
      }
    }
  }, [_vm._v("编辑地区\n              ")])], 1)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.valuation == 4),
      expression: "form.valuation == 4"
    }],
    staticClass: "section section-white"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("运费计算:")]), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("默认运费:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "140"
    }
  }, [_vm._v("\n              体积（m³以内）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_volume_conf[0].start_standard),
      callback: function($$v) {
        _vm.$set(_vm.fee_volume_conf[0], "start_standard", $$v)
      },
      expression: "fee_volume_conf[0].start_standard"
    }
  }), _vm._v("\n              运费（元）：\n              "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.fee_volume_conf[0].start_fee),
      callback: function($$v) {
        _vm.$set(_vm.fee_volume_conf[0], "start_fee", $$v)
      },
      expression: "fee_volume_conf[0].start_fee"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "font-bold"
  }, [_vm._v("增体积运费:")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "140"
    }
  }, [_vm._v("\n              每增加（m³内）：\n              "), _c('el-input', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.fee_volume_conf[0].add_standard),
      callback: function($$v) {
        _vm.$set(_vm.fee_volume_conf[0], "add_standard", $$v)
      },
      expression: "fee_volume_conf[0].add_standard"
    }
  }), _vm._v("\n              增加（元）：\n              "), _c('el-input', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: (_vm.fee_volume_conf[0].add_fee),
      callback: function($$v) {
        _vm.$set(_vm.fee_volume_conf[0], "add_fee", $$v)
      },
      expression: "fee_volume_conf[0].add_fee"
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区城市设置运费")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fee_volume_conf.slice(1),
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "运送到",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleVolumeFeeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首体积(m³)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.start_standard),
            callback: function($$v) {
              _vm.$set(scope.row, "start_standard", $$v)
            },
            expression: "scope.row.start_standard"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "首费(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.start_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "start_fee", $$v)
            },
            expression: "scope.row.start_fee"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续体积(m³)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.add_standard),
            callback: function($$v) {
              _vm.$set(scope.row, "add_standard", $$v)
            },
            expression: "scope.row.add_standard"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续费(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.add_fee),
            callback: function($$v) {
              _vm.$set(scope.row, "add_fee", $$v)
            },
            expression: "scope.row.add_fee"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleVolumeFeeDeleteArea(scope.$index)
            }
          }
        }, [_vm._v("删除\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('fee_volume_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("不配送城市（优先级最高）")]), _vm._v(" "), (_vm.nopost_volume_conf && _vm.nopost_volume_conf.length > 0) ? _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v(_vm._s(_vm._f("formatCityData")(_vm.nopost_volume_conf, _vm.district)))]) : _c('p', {
    staticClass: "font-bold nopost"
  }, [_vm._v("暂无数据")]), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleVolumeNoPostEditArea()
      }
    }
  }, [_vm._v("编辑地区\n              ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "font-bold"
  }, [_c('el-checkbox', {
    attrs: {
      "value": _vm.volumeFreeStatus
    },
    model: {
      value: (_vm.volumeFreeStatus),
      callback: function($$v) {
        _vm.volumeFreeStatus = $$v
      },
      expression: "volumeFreeStatus"
    }
  }), _vm._v("\n            指定条件包邮:\n          ")], 1), _vm._v(" "), (_vm.volumeFreeStatus) ? _c('section', {
    staticClass: "section section-white shipping-calc"
  }, [_c('p', {
    staticClass: "font-bold"
  }, [_vm._v("为指定地区设置包邮规则")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.free_volume_conf,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "地区设置",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatCityData")(scope.row.area, _vm.district)) + "\n                  "), (scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "el-icon-edit",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.handleVolumeFreeEditArea(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑\n                  ")]) : _vm._e()]
      }
    }], null, false, 2625767069)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "包邮条件(m³)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100px"
          },
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.freetype),
            callback: function($$v) {
              _vm.$set(scope.row, "freetype", $$v)
            },
            expression: "scope.row.freetype"
          }
        }, _vm._l((_vm.options_volume), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1), _vm._v(" "), (1 == scope.row.freetype || 3 == scope.row.freetype) ? _c('span', [_vm._v("在 "), _c('el-input', {
          staticClass: "inline-input",
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.upvolume),
            callback: function($$v) {
              _vm.$set(scope.row, "upvolume", $$v)
            },
            expression: "scope.row.upvolume"
          }
        }), _vm._v(" m³内包邮")], 1) : _vm._e(), _vm._v(" "), (2 == scope.row.freetype || 3 == scope.row.freetype) ? _c('span', [(3 == scope.row.freetype) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v(" "), _c('el-input', {
          staticClass: "inline-input",
          staticStyle: {
            "width": "100px"
          },
          model: {
            value: (scope.row.upmoney),
            callback: function($$v) {
              _vm.$set(scope.row, "upmoney", $$v)
            },
            expression: "scope.row.upmoney"
          }
        }), _vm._v(" 元以上包邮")], 1) : _vm._e()]
      }
    }], null, false, 1611460234)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(0 != scope.$index) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "icon": "delete",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.handleVolumeFreeDeleteArea(scope.$index)
            }
          }
        }, [_vm._v("删除\n                  ")]) : _vm._e()]
      }
    }], null, false, 1812949104)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-v-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.handleAddArea('free_volume_conf')
      }
    }
  }, [_vm._v("添加地区\n              ")])], 1)], 1) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitSaveAction
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择区域",
      "visible": _vm.dialogAreaFormVisible,
      "width": "960px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAreaFormVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', [_vm._v("小程序版本在v2.3.2（不包含v2.3.2）以上地区选择才有效，请及时升级小程序 >> "), _c('router-link', {
    attrs: {
      "to": {
        path: '/wxapp/manage/editauthorize'
      }
    }
  }, [_vm._v("小程序版本")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', {
    staticClass: "province-list"
  }, [_c('el-col', [_vm._v("省份")]), _vm._v(" "), _vm._l((_vm.areaInfo), function(item, index) {
    return _c('el-col', {
      key: 'province' + index,
      style: (_vm.provinceIndex == index ? 'background: #ddd' : '')
    }, [_c('el-checkbox', {
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "value": item.value
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckProvinceChange(index, item.checked)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v("\n                " + _vm._s(item.label) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "el-icon-caret-right",
      on: {
        "click": function($event) {
          return _vm.handlechildProvinceChoose(index)
        }
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), (_vm.provinceIndex > -1) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', {
    staticClass: "city-list"
  }, [_c('el-col', [_vm._v("城市")]), _vm._v(" "), _vm._l((_vm.areaInfo[_vm.provinceIndex].children), function(item, index) {
    return _c('el-col', {
      key: 'city' + index,
      style: (_vm.cityIndex == index ? 'background: #ddd' : '')
    }, [_c('el-checkbox', {
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "value": item.value
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckCityChange(index, item.checked)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("subStr")(item.label, 12)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "el-icon-caret-right",
      on: {
        "click": function($event) {
          return _vm.handlechildCityChoose(index)
        }
      }
    })], 1)
  })], 2)], 1) : _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', {
    staticClass: "region-list"
  }, [_c('el-col', [_vm._v("城市")])], 1)], 1), _vm._v(" "), (_vm.cityIndex > -1) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', {
    staticClass: "region-list"
  }, [_c('el-col', [_vm._v("地区")]), _vm._v(" "), _vm._l((_vm.areaInfo[_vm.provinceIndex].children[_vm.cityIndex].children), function(item, index) {
    return _c('el-col', {
      key: 'city' + index
    }, [_c('el-checkbox', {
      attrs: {
        "value": item.value
      },
      on: {
        "change": function($event) {
          return _vm.handleCheckRegionChange(index, item.checked)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("subStr")(item.label, 12)) + "\n              ")])], 1)
  })], 2)], 1) : _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', {
    staticClass: "region-list"
  }, [_c('el-col', [_vm._v("地区")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-row', {
    staticClass: "region-list"
  }, [_c('el-col', [_vm._v("\n              已选："), _c('br'), _vm._v("\n              " + _vm._s(_vm._f("formatCityData")(_vm.conf_area, _vm.district, false)) + "\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogAreaFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAreaChooseFinish
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b82e283", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b82e283"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/shipping/add.vue
// module id = 2569
// module chunks = 0